<template>
  <span class="d-md-none font-weight-bold position-relative dropdown">
    <button
      aria-expanded="false"
      aria-haspopup="true"
      class="mobile-location-btn font-14 cursor-pointer font-weight-bold dropdown-toggle"
      data-bs-toggle="dropdown"
    >
      {{ $store.state.selectedSiteForScheduler.site_shortname }}
      <img
        alt="select option type"
        class="ml-1"
        :src="getIcon('chevron-down-solid.svg')"
        width="10"
      />
    </button>
    <ul class="dropdown-menu p-0 mobile-location-dropdown">
      <li v-for="(location, lc) in $store.state.allSites" :key="lc">
        <a
          class="dropdown-item font-14 mobile-location-item"
          href="#"
          @click.prevent="selectLocation(location)"
        >
          {{ location.site_shortname }}
        </a>
      </li>
    </ul>
  </span>
</template>

<script>
export default {
  name: 'MobileLocationSelector',
  emits: ['location-changed'],
  methods: {
    getIcon(img) {
      return require('@/assets/icons/' + img);
    },
    selectLocation(location) {
      this.$store.commit('SET_SELECTED_SITE', location);
      this.$emit('location-changed', location);
    },
  },
};
</script>

<style scoped>
.mobile-location-btn {
  background: transparent;
  border: none;
  color: #fff;
  padding: 0;
}

.mobile-location-btn::after {
  display: none;
}

.mobile-location-dropdown {
  border-radius: 4px !important;
  background: #2c2c2c !important;
  min-width: 160px;
  right: 0 !important;
  left: auto !important;
}

.mobile-location-item {
  padding: 8px 16px !important;
  color: #fff !important;
  background: transparent;
}

.mobile-location-item:hover,
.mobile-location-item:focus {
  background: #0e4f74 !important;
  color: #fff !important;
}
</style>
